'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconEmailSend = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M23.309 1.038l-23 9.5a.5.5 0 0 0 .01.928L9 14.842V22.5c0 .509.675.691.932.252l3.288-5.636 6.04 3.321a.5.5 0 0 0 .729-.332l4-18.5c.083-.417-.342-.709-.68-.567zm-2.182 1.983L9.389 13.92l-7.545-2.935 19.283-7.964zM10 20.65v-5.305l2.343 1.288L10 20.65zm9.153-1.411l-8.806-4.844L22.675 2.948l-3.522 16.291z' }),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { fill: 'none', d: 'M0 0h24v24H0z' })
    )
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M23.309 1.038l-23 9.5a.5.5 0 0 0 .01.928L9 14.842V22.5c0 .509.675.691.932.252l3.288-5.636 6.04 3.321a.5.5 0 0 0 .729-.332l4-18.5c.083-.417-.342-.709-.68-.567zm-2.182 1.983L9.389 13.92l-7.545-2.935 19.283-7.964zM10 20.65v-5.305l2.343 1.288L10 20.65zm9.153-1.411l-8.806-4.844L22.675 2.948l-3.522 16.291z' }),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { fill: 'none', d: 'M0 0h24v24H0z' })
    )
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M23.309 1.038l-23 9.5a.5.5 0 0 0 .01.928L9 14.842V22.5c0 .509.675.691.932.252l3.288-5.636 6.04 3.321a.5.5 0 0 0 .729-.332l4-18.5c.083-.417-.342-.709-.68-.567zm-2.182 1.983L9.389 13.92l-7.545-2.935 19.283-7.964zM10 20.65v-5.305l2.343 1.288L10 20.65zm9.153-1.411l-8.806-4.844L22.675 2.948l-3.522 16.291z' }),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { fill: 'none', d: 'M0 0h24v24H0z' })
    )
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconEmailSend.displayName = 'IconEmailSend';
exports.default = IconEmailSend;